module.exports = __webpack_public_path__ + "img/beer_id-119.f4b58227.png";